import {store} from './index';
import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';
import {IUser} from '@/types/iUser';

@Module({ namespaced: true, dynamic: true, store, name: 'storeUser'})
export default class User extends VuexModule {
  public user: IUser = {
    userid: '',
    email: '',
    lastName: '',
    firstName: '',
    job: '',
    division: '',
    department: '',
    isAuthenticated: false,
    csrf_token: ''
  };

  public MyImgProfileString64: string = '';

  @Mutation
  public SET_USER(puser: IUser) {
    this.user = puser;
  }
  @Action
  public set_user(puser: IUser) {
    this.context.commit('SET_USER', puser);
  }


  @Mutation
  public SET_CSRF_TOKEN(ptoken: string) {
    this.user.csrf_token = ptoken;
  }
  @Action
  public set_csrf_token(ptoken: string) {
    this.context.commit('SET_CSRF_TOKEN', ptoken);
  }

  @Mutation
  public SET_MYIMGPROFILESTRING64R(pimgstring: string) {
    this.MyImgProfileString64 = pimgstring;
  }
  @Action
  public set_myimgprofilestring64r(pimgstring: string) {
    this.context.commit('SET_MYIMGPROFILESTRING64R', pimgstring);
  }

}
